import { ContentFull, ContentHeader } from "components/layout";
import { TemplateSelect } from "components/templates/template-select";
import React from "react";
import { useTenantSettings } from "store/selectors/settings";

export const AgencySettingsFax: React.FC<unknown> = () => {
    const { settings, putSetting } = useTenantSettings();
    return (
        <div className="space-y-4 lg:space-y-8">
            <ContentFull>
                <ContentHeader>Fax</ContentHeader>
                <div className="space-y-4">
                    <TemplateSelect
                        label="Cover page"
                        sharedOnly
                        selectedTemplateId={settings.faxCoverPageTemplateId}
                        onChange={id => {
                            putSetting("faxCoverPageTemplateId", id);
                        }}
                    />
                </div>
            </ContentFull>
        </div>
    );
};
